// extracted by mini-css-extract-plugin
export default {"details__container":"style_details__container__YIxwO","details__list":"style_details__list__x2NPm","details__title":"style_details__title__nyR0r"};